enum StatusofTraining {
  H1 = 1,
  H2 = 2,
  C1 = 3,
  C2 = 4,
  PartTime = 5
}

enum EndorsementUser {
  COS = 1,
  Supervisor = 2
}

enum CompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Completed = 90
}

enum Status {
  Saved = 0,
  Released = 11,
  SubmittedByTrainee = 21,
  ReSubmittedByTrainee = 22,
  Endorsed = 53,
  Rejected = 54
}

enum ActionType {
  Saved = 0,
  Released = 11,
  Submitted = 21,
  ResubmittedbyTrainee = 22,
  Endorsed = 53,
  Rejected = 54
}

enum SpecilatyDesc {
  FamilyMedicine = 2
}

export const annualCheckingEnum = {
  StatusofTraining,
  EndorsementUser,
  CompletionStatus,
  Status,
  ActionType,
  SpecilatyDesc
}
